module.exports = "<p>\n  random works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/Guest/Desktop/meme/src/app/random/random.component.html
// module id = ../../../../../src/app/random/random.component.html
// module chunks = main